import axios from 'axios';
import apiUrl from '../../api.config';

const DEPARTMENT_API_URL = `${apiUrl}departments`;

// Add headers configuration
const getAuthHeaders = () => ({
    headers: {
        'x-access-token': localStorage.getItem('accessToken')
    }
});

export const DepartmentApiService = {
    // 創建新部門
    createDepartment: async (departmentData) => {
        try {
            const response = await axios.post(DEPARTMENT_API_URL, departmentData, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 獲取所有部門
    getAllDepartments: async () => {
        try {
            const response = await axios.get(DEPARTMENT_API_URL, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 根據學校 ID 獲取部門
    getDepartmentsBySchool: async () => {
        try {
            const response = await axios.get(`${DEPARTMENT_API_URL}/getBySchool`, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 獲取單個部門詳情
    getDepartmentById: async (id) => {
        try {
            const response = await axios.get(`${DEPARTMENT_API_URL}/${id}`, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 更新部門資訊
    updateDepartment: async (id, departmentData) => {
        try {
            const response = await axios.put(`${DEPARTMENT_API_URL}/${id}`, departmentData, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    },

    // 刪除部門
    deleteDepartment: async (id) => {
        try {
            const response = await axios.delete(`${DEPARTMENT_API_URL}/${id}`, getAuthHeaders());
            return response.data;
        } catch (error) {
            throw error.response?.data || error.message;
        }
    }
};

export default DepartmentApiService; 